import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum ChargeSettlementReduxTypes {
  FETCH_CHARGE_SETTLEMENTS_REQUEST = "@@auth/FETCH_CHARGE_SETTLEMENTS_REQUEST",
  FETCH_CHARGE_SETTLEMENTS_SUCCESS = "@@auth/FETCH_CHARGE_SETTLEMENTS_SUCCESS",
  FETCH_CHARGE_SETTLEMENTS_ERROR = "@@auth/FETCH_CHARGE_SETTLEMENTS_ERROR",

  FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_REQUEST = "@@auth/FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_REQUEST",
  FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_SUCCESS = "@@auth/FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_SUCCESS",
  FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_ERROR = "@@auth/FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_ERROR",

  CREATE_CHARGE_SETTLEMENT_REQUEST = "@@auth/CREATE_CHARGE_SETTLEMENT_REQUEST",
  CREATE_CHARGE_SETTLEMENT_SUCCESS = "@@auth/CREATE_CHARGE_SETTLEMENT_SUCCESS",
  CREATE_CHARGE_SETTLEMENT_ERROR = "@@auth/CREATE_CHARGE_SETTLEMENT_ERROR",

  CHARGE_SETTLEMENT_APPROVE_REQUEST = "@@auth/CHARGE_SETTLEMENT_APPROVE_REQUEST",
  CHARGE_SETTLEMENT_APPROVE_SUCCESS = "@@auth/CHARGE_SETTLEMENT_APPROVE_SUCCESS",
  CHARGE_SETTLEMENT_APPROVE_ERROR = "@@auth/CHARGE_SETTLEMENT_APPROVE_ERROR",

  CHARGE_SETTLEMENT_REJECT_REQUEST = "@@auth/CHARGE_SETTLEMENT_REJECT_REQUEST",
  CHARGE_SETTLEMENT_REJECT_SUCCESS = "@@auth/CHARGE_SETTLEMENT_REJECT_SUCCESS",
  CHARGE_SETTLEMENT_REJECT_ERROR = "@@auth/CHARGE_SETTLEMENT_REJECT_ERROR",

  FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_REQUEST = "@@auth/FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_REQUEST",
  FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_SUCCESS = "@@auth/FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_SUCCESS",
  FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_ERROR = "@@auth/FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_ERROR",

  RESET_CREATE_CHARGE_SETTLEMENT = "@@auth/RESET_CREATE_CHARGE_SETTLEMENT",
  RESET_APPROVE_CHARGE_SETTLEMENT = "@@auth/RESET_APPROVE_CHARGE_SETTLEMENT",
  RESET_REJECT_CHARGE_SETTLEMENT = "@@auth/RESET_REJECT_CHARGE_SETTLEMENT",

  RESET = "@@Repayment/chargeSettlement/RESET",

  SET_CHARGE_SETTLEMENT_LIST_UI = "@@chargeSettlement/SET_LIST_UI",
  RESET_CHARGE_SETTLEMENT_LIST_UI = "@@chargeSettlement/RESET_LIST_UI"
}
export type ChargeSettlementListUiState = {
  currentPage: number;
  searchFilter: Record<string, any>;
  sort: { field: string; order: boolean };
  isFilterApplied: boolean;
};


export type ChargeSettlementActionDispatch = {
  type:
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_REQUEST
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_REQUEST
    | ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_REQUEST
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_REQUEST
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_REQUEST
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_REQUEST
    | ChargeSettlementReduxTypes.RESET_CREATE_CHARGE_SETTLEMENT
    | ChargeSettlementReduxTypes.RESET_APPROVE_CHARGE_SETTLEMENT
    | ChargeSettlementReduxTypes.RESET_REJECT_CHARGE_SETTLEMENT
    | ChargeSettlementReduxTypes.RESET;

  payload: any;
};
export type ChargeSettlementReducerDispatch = {
  type:
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_REQUEST
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_SUCCESS
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_ERROR
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_REQUEST
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_SUCCESS
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_ERROR
    | ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_REQUEST
    | ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_SUCCESS
    | ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_ERROR
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_REQUEST
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_SUCCESS
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_ERROR
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_REQUEST
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_SUCCESS
    | ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_ERROR
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_REQUEST
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_SUCCESS
    | ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_ERROR
    | ChargeSettlementReduxTypes.RESET_CREATE_CHARGE_SETTLEMENT
    | ChargeSettlementReduxTypes.RESET_APPROVE_CHARGE_SETTLEMENT
    | ChargeSettlementReduxTypes.RESET_REJECT_CHARGE_SETTLEMENT
    | ChargeSettlementReduxTypes.RESET;

  payload: {
    data?: FetchApiResponse<ChargeSettlement>;
    error?: string;
  };
};

export type ChargeSettlementReduxState = {
  loading?: boolean;
  data?: FetchApiResponse<ChargeSettlement>;
  error?: string | null;
};

export type ChargeSettlement = {
  id: string;
  externalId: string;
  chargeId: string;
  chargeDetails: chargesCompact;
  repaymentsRequestId: string;
  settledAmount: number;
  settledCgstAmount: number;
  settledSgstAmount: number;
  settledIgstAmount: number;
  transactionDate: string;
  status: string;
  createdOn: string;
  updatedOn: string;
};
type chargesCompact = {
  id: string;
  externalId: string;
  status: string;
  programmeExternalId: string;
  programmeName?: string;
  settlementStatus: string;
  customerExternalId?: string;
  customerName?: string;
  borrowerExternalId: string;
  customerRelationExternalId: string;
  exposureOn: string;
  chargeType: string;
  gstPercentage: number;
  amountWithoutGst: number;
  gstAmount: number;
  totalAmount: number;
  pendingAmount: number;
  pendingCgstAmount: number;
  pendingSgstAmount: number;
  pendingIgstAmount: number;
  settledAmount: number;
};
export type FetchChargeSettlementByIdRequest = {
  payload: FilterMetadata;
  type: string;
};

export type FetchChargeSettlementsReq = {
  payload: FilterMetadata;
  type: string;
};

export type FetchChargeSettlementsAuditActionsReq = {
  payload: FilterMetadata;
  type: string;
};

export type CreateChargeSettlement = {
  chargeId: string;
  amount: number;
  settlementDate: string;
  utr: string;
  comment: string  | null;
  chargeBaseType: string;
  makerRemarks: string;
};

export type CreateChargeSettlementReduxState = {
  loading?: boolean;
  data?: CreateApiResponse<ChargeSettlement>;
  error?: string | null;
};

export type CreateChargeSettlementRequest = {
  payload: CreateChargeSettlement;
  type: string;
};

export type ApproveRejectChargeSettlement = {
  checkerRemarks: string;
};
export type ApproveRejectChargeSettlementRequest = {
  payload: ApproveRejectChargeSettlement;
  type: string;
};
